import React from "react";
import { Link } from "react-router-dom";
import "./Content.css";

const Content = () => {
  return (
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-3 d-none d-md-block"></div>
          <div className="col-12 col-lg-6">
            <h5 className="content-heading">Start using IDE-Cloud for free!</h5>
            <p className="content-text">
              Over 80+ features bundled into one single solution to make your
              BizTalk Server monitoring and administration super efficient and
              secure.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-2 col-md-3 col-lg-4"></div>
          <div className="col-4 col-md-3 col-lg-2">
            <Link to="/free-trial">
              <button className="btn btn-trial">Free 30-day Trial</button>
            </Link>
          </div>
          <div className="col-4 col-md-3 col-lg-2">
            <Link to="/request-demo">
              <button className="btn btn-demo btn-outline-secondary">
                Book a Demo
              </button>
            </Link>
          </div>
          <div className="col-2 col-md-3 col-lg-4"></div>
        </div>
      </div>
    </div>
  );
};

export default Content;
